// removed by extract-text-webpack-plugin
module.exports = {"root":"_1mC4N","item":"_2OVzP","label":"_1Ai0e","icon":"_3qFv3","active":"_-JdXj","itemContent":"_AqfLR","animate":"_3AcBN","hidden":"_1mX_E","visible":"_37fah","hide":"_3j32V"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Accordion/Accordion.scss
// module id = 1346
// module chunks = 1